<template lang="pug">
  .component-packet-form
    .row
      .column
        label Token
        input(type="text", v-model="localValue.token")
        label Destination
        select(v-model="localValue.destination_type", @change="()=>localValue.destination_id = null")
          option(:value="null") Select an option
          option(v-for="(destination,key) in destinations" :value="key" ) {{destination}}

        selectize-plan(v-model="localValue.destination_id", :value-field="true", v-if="localValue.destination_type ==='App\\\\Models\\\\Plan'" )
        selectize-common-cost(v-model="localValue.destination_id", :value-field="true", v-if="localValue.destination_type ==='App\\\\Models\\\\CommonCost'")
        selectize-federation(v-model="localValue.destination_id", :value-field="true", v-if="localValue.destination_type ==='App\\\\Models\\\\Federation'")

      .column
        label Additional
          select(v-model="additional_type")
            option(:value="null") Select an option
            option(v-for="(destination,key) in destinations" :value="key" ) {{destination}}
        selectize-plan(v-model="additional_id", :value-field="true", v-if="additional_type ==='App\\\\Models\\\\Plan'" )
        selectize-common-cost(v-model="additional_id", :value-field="true", v-if="additional_type ==='App\\\\Models\\\\CommonCost'")
        selectize-federation(v-model="additional_id", :value-field="true", v-if="additional_type ==='App\\\\Models\\\\Federation'")
        button.small.button(@click="addAdditional", :disabled="(additional_type === null || additional_id === null) && additional_type !== 'App\\\\Models\\\\PaymentMethod'") Add
        .prop-item(v-for="(value, i) in localValue.additional")
          .input-group
            span.input-group-label {{value.class.split('\\')[value.class.split('\\').length -1]}}
            input.input-group-field(type="text" disabled, :value="value.id")
            .input-group-button
              button.button.warning.fa.fa-times(@click="()=>{localValue.additional.splice(i,1)}")
</template>

<script>
import BaseForm from './BaseForm.vue';
import Editor from "../ui/Editor.vue";
import TranslateField from "../../../pages/backoffice/TranslateField.vue";
import SelectizePlan from "../ui/lists/selectize/SelectizePlan.vue";
import SelectizeCommonCost from "../ui/lists/selectize/SelectizeCommonCost.vue";
import SelectizeFederation from "../ui/lists/selectize/SelectizeFederation.vue";

export default {
  name: "RegistrationTokenForm",
  extends: BaseForm,
  components: {SelectizeFederation, SelectizeCommonCost, SelectizePlan, TranslateField, BaseForm, Editor},
  data() {
    return {
      destinations: {
        'App\\Models\\Plan': 'Plan',
        'App\\Models\\Federation': 'Federation',
        'App\\Models\\CommonCost': 'Common Cost',
        'App\\Models\\PaymentMethod': 'Offline Payment method',
      },
      additional_type: null,
      additional_id: null,
    }
  },
  methods: {
    addAdditional() {
      this.localValue.additional.push({class: this.additional_type, id: this.additional_id})
      this.additional_type = null
      this.additional_id = null
    }
  }
};
</script>



// WEBPACK FOOTER //
// RegistrationTokenForm.vue?368d9977